import Breadcrumb from "components/Navigation/Breadcrumb";
import TitleMenu from "components/Navigation/TitleMenu";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { getEnvCode, useSalesNetwork } from "utils/hooks/useSalesNetworks";
import useTranslation from "utils/hooks/useTranslation";
import jsonLogic from "json-logic-js"
import { useLazyGetAccessoriesQuery } from "store/api";
import Acc from "./StepAcc/Acc";
import { SvgArrow, SvgInfo, SvgSupprimer } from "components/svg";
import NavigationButtons from "components/NavigationButtons";
import { addNotification } from "store/componentsSlice";
import { toJS } from "utils/helpers";
import { useProject } from "utils/hooks/useProject";

const ProjectStepAcc: React.FC = () => {
    const { t } = useTranslation();
    const { network, isThermor } = useSalesNetwork();
    const dispatch = useAppDispatch();
    const { saveStore, nextStep, setAccessories } = useProject();
    const projectStore = useAppSelector((state) => state.project);
    const [luaService_getAccessories] = useLazyGetAccessoriesQuery();
    const [state, setState] = useState<{
        selectedGroup: any;
        recommendedAccessories: any[];
        otherAccessories: any[];
        accessoriesGroups: any[];
    }>({
        selectedGroup: null,
        recommendedAccessories: [],
        otherAccessories: [],
        accessoriesGroups: [],
    })

    //const fleche_titre = imgChevrons[network?._parameters.brand] || fleche_titre_atlantic

    let currentDep: any[] = useMemo(
        () => ([]),
        []
    );

    const selectedAccessoriesCount = function () {
        let count: number = 0;
        state.otherAccessories.forEach((acc: any) => {
            if (acc._selected) {
                count++;
            }
        })
        return count;
    }

    const sortAccessories: any = useCallback((accessories: any) => {
        const recommendedAccessories: any[] = []
        const otherAccessories: any[] = []
        const data = toJS(projectStore.project)

        accessories.forEach((acc: any) => {
            let result

            try {
                result = acc._accessory.select_rules
                    ? jsonLogic.apply(
                        JSON.parse(acc._accessory.select_rules), // Rule
                        data, // Data
                    )
                    : false
            } catch {
                result = false
                console.log('Err parsing accessory ' + acc._accessory.code + ' rules')
            }

            try {
                if (acc._accessory.quote_rules) {
                    const test = acc._accessory.quote_rules
                        ? jsonLogic.apply(
                            JSON.parse(acc._accessory.quote_rules), // Rule
                            data, // Data
                        )
                        : false

                    if (result === test) {
                        acc._qty = projectStore.project.forms.heatModeStep.form.zones.length
                    } else {
                        acc._qty = 1
                    }
                }
            } catch {
                console.log('Err parsing accessory ' + acc._accessory.code + ' rules')
            }

            otherAccessories.push(acc)
        })

        return { recommendedAccessories, otherAccessories }
    }, [projectStore])

    useEffect(() => { //NOSONAR
        async function fetchAccessories() {
            let oldAccessories: any;
            if (projectStore.project.accessories) { // NOSONAR
                oldAccessories = projectStore.project.accessories
            }

            let accessories = await luaService_getAccessories({ env: getEnvCode(), productCode: projectStore.project.selectedProduct?.product.code_env }).unwrap();


            if (oldAccessories) { // NOSONAR
                oldAccessories = (oldAccessories['recommendedAccessories'] || []).slice().concat(oldAccessories['otherAccessories'].slice())

                const _accessories: any[] = [];
                accessories?.forEach((acc: any) => {
                    const found = oldAccessories.find((oacc: any) => oacc.id === acc.id)
                    if (found) { // NOSONAR
                        const _acc = { ...acc, _selected: found._selected, _qty: found._qty };
                        //accessories[index]._selected = found._selected
                        //accessories[index]._qty = found._qty
                        _accessories.push(_acc);
                    } else {
                        _accessories.push(acc);
                    }
                })
                accessories = _accessories;
            }

            if (accessories && accessories.length > 0) { // NOSONAR
                const groups: any[] = [];
                const sortedAccessories = sortAccessories(accessories);

                accessories.forEach((acc: any) => {
                    if (!acc._recommended && !groups[acc._accessory._accessorygroup_description]) { // NOSONAR
                        groups[acc._accessory._accessorygroup_description] = {
                            id: acc._accessory.accessorygroup_id,
                            order: acc._accessory_group_order,
                            label: acc._accessory._accessorygroup_description,
                        }
                    }
                })

                const accessoriesGroups = Object.values(groups)
                accessoriesGroups.sort((a: any, b: any) => {
                    // Use toUpperCase() to ignore character casing
                    const A = a.order
                    const B = b.order

                    let comparison = 0
                    if (A > B) { // NOSONAR
                        comparison = 1
                    } else if (A < B) { // NOSONAR
                        comparison = -1
                    }
                    return comparison;
                })

                setState({
                    accessoriesGroups: accessoriesGroups,
                    recommendedAccessories: sortedAccessories.recommendedAccessories,
                    otherAccessories: sortedAccessories.otherAccessories,
                    selectedGroup: accessoriesGroups[0]?.id,
                })
            }
        }
        fetchAccessories()

    }, []);



    /**
     * Check if one selected accessory depend on "acc"
     * We can't unselect an accessory which has selected accessories that depend on it
     * @param acc
     * @returns {*}
     */
    const checkAccessoryReverveDependency = useCallback((acc: any) => {
        let reverveDependencyDetected = null

        const accessoryLists = [state.recommendedAccessories, state.otherAccessories]

        accessoryLists.forEach((list) => {
            list.forEach((a: any) => {
                if (a.dep && a.dep.length > 0) {
                    a.dep.forEach((dep: any) => {
                        if (a._selected && dep === acc.id) {
                            reverveDependencyDetected = { parent: { id: acc.id, code_env: acc.code_env }, child: { id: a.id, code_env: a.code_env } }
                        }
                    })
                }
            })
        })

        return reverveDependencyDetected
    }, [state])

    const selectAccessory = useCallback((e: any, item: any) => { //NOSONAR
        const acc = { ...item };
        if (!acc._selected) {
            const result: any = checkAccessoryDependency(acc)
            if (result) {

                /**
                 * if(result.child != acc.id) toast.warning(acc.id + " DEPEND DE " + result.child + ' MAIS ' + result.child + " INC AVEC " + result.parent)
                 * else toast.warning(result.child + " INC AVEC " + result.parent)
                 */

                const { child, parent } = result
                if (result.child.id !== acc.id)
                    dispatch(addNotification({
                        type: "warning",
                        message: t('ACCESSORY_DEPENDENCY_AND_INCOMPATIBILiTY_DETECTED', { child: child.code_env, parent: parent.code_env, acc: acc.code_env })
                    }))
                else {
                    dispatch(addNotification({
                        type: "warning",
                        message: t('ACCESSORY_INCOMPATIBILiTY_DETECTED', { child: child.code_env, parent: parent.code_env })
                    }))
                }

                return
            } else {
                if (e) currentDep = []
                checkAccessoryDependency(acc, true)
            }
        } else {
            const accessoryNotDeselectable = ['700436', '700437', '700432', '700433', '700434', '075327']
            if (accessoryNotDeselectable.find((c: any) => c === acc.code_env)) {
                dispatch(addNotification({
                    type: "warning",
                    message: t('NOT_DESELECTABLE_ACCESSORY')
                }))
                return
            }

            const result: any = checkAccessoryReverveDependency(acc)
            if (result) {
                const { child, parent } = result
                //toast.warning(result.child + " DEPEND DE " + result.parent) // NOSONAR
                dispatch(addNotification({
                    type: "warning",
                    message: t('ACCESSORY_DEPENDENCY_DETECTED', { child: child.code_env, parent: parent.code_env })
                }))
                return
            }

            if (acc._recommended) {
                dispatch(addNotification({
                    type: "warning",
                    message: t('UNSELECT_RECOMMENDED_ACCESSORY')
                }))
            }
        }

        acc._selected = !acc._selected

        if (!acc._selected) {
            acc._qty = null
            acc._discount = null
        } else {
            acc._qty = 1
        }

        const _otherAccessories: any[] = []
        state.otherAccessories.map((item: any) => {
            if (acc.id === item.id) {
                _otherAccessories.push({ ...item, _qty: acc._qty, _discount: acc._discount, _selected: acc._selected });
            } else {
                _otherAccessories.push(item);
            }
        })

        setState((prevState) => ({ ...prevState, otherAccessories: _otherAccessories }))

        if (e) currentDep = []
    }, [state, setState])

    const clearAccessoryes = useCallback((e: any) => { //NOSONAR
        const _otherAccessories: any[] = []
        state.otherAccessories.forEach((item: any) => {
            const acc = { ...item };
            if (acc._selected) {
                const accessoryNotDeselectable = ['700436', '700437', '700432', '700433', '700434', '075327']
                if (accessoryNotDeselectable.find((c: any) => c === acc.code_env)) {
                    dispatch(addNotification({
                        type: "warning",
                        message: t('NOT_DESELECTABLE_ACCESSORY')
                    }))
                    return
                }

                const result: any = checkAccessoryReverveDependency(acc)
                if (result) {
                    const { child, parent } = result
                    //toast.warning(result.child + " DEPEND DE " + result.parent) // NOSONAR
                    dispatch(addNotification({
                        type: "warning",
                        message: t('ACCESSORY_DEPENDENCY_DETECTED', { child: child.code_env, parent: parent.code_env })
                    }))
                    return
                }

                if (acc._recommended) {
                    dispatch(addNotification({
                        type: "warning",
                        message: t('UNSELECT_RECOMMENDED_ACCESSORY')
                    }))
                }

                acc._selected = false
                acc._qty = null
                acc._discount = null

                _otherAccessories.push({ ...item, _qty: acc._qty, _discount: acc._discount, _selected: acc._selected });
            } else {
                _otherAccessories.push(item);
            }


        })


        setState((prevState) => ({ ...prevState, otherAccessories: _otherAccessories }))

        if (e) currentDep = []
    }, [state, setState])

    /**
     * Check if an accessory depend on other accessories
     * Check if an accessory is incomatible with already selected accessory
     * @param acc
     * @param selectMode -> auto check depend accessories
     * @returns {*}
     */
    const checkAccessoryDependency = useCallback((acc: any, selectMode: any = null) => { //NOSONAR
        currentDep.push('' + acc.id)

        let incompatibilityDetected = null

        const accessoryLists = [state.recommendedAccessories, state.otherAccessories]

        if (acc._accessory.dep && acc._accessory.dep.length > 0) {
            acc._accessory.dep.forEach((dep: any) => {
                accessoryLists.forEach((list: any) => {
                    list.forEach((a: any) => {
                        if (a.id === dep && !currentDep.includes(dep)) {
                            console.log(a.id + ', ' + dep + ', ' + currentDep.includes(dep))
                            currentDep.forEach((it: any) => console.log('plop' + it))
                            if (!a._selected) {
                                if (!selectMode) {
                                    incompatibilityDetected = checkAccessoryDependency(a)
                                } else {
                                    selectAccessory(null, a)
                                    dispatch(addNotification({
                                        type: "success",
                                        message: t('ACCESSORY_DEPENDENCY_SELECTED', { child: acc.code_env, parent: a.code_env })
                                    }))
                                }
                            }
                        }
                    })
                })
            })
        }

        if (incompatibilityDetected == null) {
            if (acc._accessory.inc && acc._accessory.inc.length > 0) {
                acc._accessory.inc.forEach((inc: any) => {
                    accessoryLists.forEach((list: any) => {
                        list.forEach((a: any) => {
                            if (a._selected && a.id === inc && !currentDep.includes(inc)) {
                                // toast.warning(acc.id + " INC " + inc) // NOSONAR
                                incompatibilityDetected = { child: { id: acc.id, code_env: acc.code_env }, parent: { id: a.id, code_env: a.code_env } }
                            }
                        })
                    })
                })
            }
        }

        return incompatibilityDetected
    }, [currentDep, state, t, dispatch, selectAccessory])



    const submit = useCallback((gotoNext: boolean = false) => {
        setAccessories(state)
        saveStore()
        if (gotoNext) nextStep()
        return Promise.resolve()
    }, [state, setAccessories, nextStep, saveStore])

    const hideNextButton = useCallback(() => {
        if (!network?._parameters.disabledSteps) return false;

        try {
            const disabledStepsArray = network?._parameters.disabledSteps?.split(',') || [];
            if (
                //disabledStepsArray.find((ds: any) => ds === 'quote') && 
                disabledStepsArray.find((ds: any) => ds === 'synthesis')
            ) return true
        } catch {
            return false
        }
    }, [network])

    //const brand = network?._parameters.brand

    const countSelected: number = selectedAccessoriesCount();
    const topNavigaionContent = (
        <>
            <div className="button large secondary outline" onClick={() => submit(true)} >
                <text data-width="auto">{t("NAV_NEXT")}</text>
                {!isThermor && <icon data-svg-size="20" data-svg-color="secondary"><SvgArrow /></icon>}
            </div>

            <group data-space-top="20" data-justify="end" data-gap="10">
                <text data-text-size="medium">{countSelected === 1 ? t("ACC_SELECTED_1") : (countSelected > 0 ? t("ACC_SELECTED", { X: countSelected }) : t("NO_ACC_SELECTED"))} </text>
                {countSelected > 0 && <div
                    className="simple secondary"
                    data-interactive=""
                    onClick={clearAccessoryes}
                >
                    <icon data-svg-size="20" data-svg-color="secondary"><SvgSupprimer /></icon>
                </div>}
            </group>
        </>
    )

    return (
        <>
            <TitleMenu title={projectStore.project.id ? projectStore.project.header.projectRef : t("MMENU_NEW_SIMULATION")} />
            <Breadcrumb
            //handleSubmit={submit}
            />

            <group data-direction="column" data-align="center" data-height="autofit" data-margin-top="10">
                <group
                    data-justify="center"
                    data-sticky-level="134"
                    data-sticky="top"
                >
                    <group data-space="20"
                        data-gap="20"
                        data-max-length='1200'
                        data-space-vertical="20"
                        data-background="white"
                        data-direction="column"
                        data-margin-top="10"
                        data-space-bottom="5"
                    >
                        <group data-align="center"

                        >
                            <group data-wrap="no" data-space="10" data-space-vertical="10" data-gap="20" data-adaptive="desktop">
                                {!isThermor && <group data-height="50" data-length="5" data-background="main"></group>}
                                <group data-length="autofit">
                                    <text data-text-size="xx-large">{t("ACCESSORIES")}</text>
                                </group>

                                <group data-length="forcefit" data-fit="1" data-justify="end">
                                    {topNavigaionContent}
                                </group>
                            </group>
                            <group data-wrap="no" data-space="10" data-space-vertical="10" data-gap="20" data-adaptive="mobile">
                                {!isThermor && <group data-height="40" data-length="5" data-background="main"></group>}
                                <group data-length="autofit">
                                    <text data-text-size="x-large">{t("ACCESSORIES")}</text>
                                </group>
                            </group>
                            <group data-length="forcefit" data-fit="1" data-justify="end" data-margin="-60" data-adaptive="mobile">
                                {topNavigaionContent}
                            </group>
                            <separator data-horizontal="" />
                        </group>
                    </group>
                </group>

                <group data-space="20" data-gap="20" data-max-length='1200' data-direction="column" data-space-top="0">

                    <group data-gap="30">
                        <group data-align="center" data-width="fir" data-space="20" data-background="error-color-lighter" data-radius="10">
                            <group data-gap="15" data-wrap="no">
                                <icon data-svg-size="20" data-svg-color="error-color"><SvgInfo /></icon>
                                <text data-color="error-color" data-text-size="large" data-wrap="wrap">{t("ACCESSORY_WARNING")}</text>
                            </group>
                        </group>

                        {state.accessoriesGroups?.map((group: any) => {
                            return (
                                <group
                                    key={'group' + group.id}
                                    data-gap="30"
                                >
                                    <group data-align="center" data-width="auto" data-gap="10">
                                        <text
                                            data-weight="600"
                                            data-text-size="large"
                                            data-ellipsis=""
                                            data-color="grey-color-dark"
                                        >
                                            {group.label}
                                        </text>
                                    </group>


                                    <group data-gap="30" data-type="grid" data-grid-template="240">
                                        {state.otherAccessories?.map((acc: any, index: number) => { // NOSONAR
                                            if (acc._accessory.accessorygroup_id !== group.id) return false
                                            return (
                                                <Acc
                                                    key={'acc2' + index} // NOSONAR
                                                    acc={acc} // NOSONAR
                                                    select={(e: any) => selectAccessory(e, acc)} // NOSONAR
                                                />
                                            )
                                        })}
                                    </group>

                                    <separator data-horizontal="" data-index="1" />
                                </group>
                            )
                        })}

                    </group>


                </group>

                <NavigationButtons handleSubmit={submit} hideNext={hideNextButton()} />
            </group>
        </>
    )
}

export default ProjectStepAcc;